<button
    [type]="type"
    [disabled]="disabled"
    [class.primary]="theme === 'primary'"
    [class.secondary]="theme === 'secondary'"
    [class.small]="size === 'small'"
    [class.disabled]="disabled"
>
    <ng-content></ng-content>
</button>